// ============================================================
// BOSCO — render-footer.js (MOD-P4.5-h1)
//
// Rend le footer unifié (liens légaux + attribution SRD 5.1) en fin
// de <body> sur toutes les pages. Calqué sur render-header.js :
// IIFE sans dépendance, compatible chargement legacy <script src>
// ET <script type="module"> (pages pilotes ESM).
//
// Usage : inclure ce script en DERNIER (après i18n.js). Aucun
// marqueur HTML requis dans la page — le footer s'injecte seul.
// Le contenu est construit via window.traduire avec fallbacks FR,
// après window.I18nPrete pour éviter un flash FR → EN.
// ============================================================

(() => {
    'use strict';

    function pretDom(cb) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', cb, { once: true });
        } else {
            cb();
        }
    }

    function construireFooter() {
        const t = (cle, fallback) => (window.traduire && window.traduire(cle, fallback)) || fallback;

        const footer = document.createElement('footer');
        footer.className = 'app-footer';

        // Liens construits en DOM (pas d'innerHTML) : contenu 100 % statique
        // mais on garde le réflexe projet « jamais d'injection de chaînes ».
        const nav = document.createElement('nav');
        nav.className = 'app-footer__nav';
        nav.setAttribute('aria-label', t('BOSCO.Footer.AriaNav', 'Informations légales'));

        const liens = [
            ['/cgu.html', t('BOSCO.Footer.Cgu', 'CGU')],
            ['/confidentialite.html', t('BOSCO.Footer.Confidentialite', 'Confidentialité')],
            ['/mentions-legales.html', t('BOSCO.Footer.MentionsLegales', 'Mentions légales')],
        ];
        for (const [href, libelle] of liens) {
            const a = document.createElement('a');
            a.className = 'app-footer__lien';
            a.href = href;
            a.textContent = libelle;
            // Page courante : pas de lien vers soi-même, juste l'état courant
            // (WCAG 2.4.8 / bonnes pratiques nav).
            if (window.location.pathname === href) {
                a.setAttribute('aria-current', 'page');
            }
            nav.appendChild(a);
        }

        const attribution = document.createElement('p');
        attribution.className = 'app-footer__attribution';
        attribution.textContent = t(
            'BOSCO.Footer.AttributionSrd',
            'Contenu du System Reference Document 5.1 (SRD 5.1) de Wizards of the Coast LLC, ' +
                'sous licence Creative Commons Attribution 4.0 International (CC-BY-4.0). ' +
                "Bosco n'est pas affilié à Wizards of the Coast.",
        );

        footer.appendChild(nav);
        footer.appendChild(attribution);
        return footer;
    }

    // Attend i18n (si présent) puis injecte. Promise.resolve() en garde de
    // sécurité si i18n.js n'est pas chargé sur la page.
    (window.I18nPrete || Promise.resolve()).then(() => {
        pretDom(() => {
            if (document.querySelector('footer.app-footer')) return; // déjà injecté
            document.body.appendChild(construireFooter());
        });
    });
})();
